module.exports = __webpack_public_path__ + "static/media/logodatavaliddemo.d08e95de.png";